import { useMemo, useCallback } from 'react';
import { Tab } from '@webmotors/eleanor-ui';
import type { ITabItem } from '@webmotors/eleanor-ui/webmotors/tab';
import { TAB_CONFIG, TAB_ORDER, MY_ADS_TEST_IDS } from '../../utils';
import type { TAdsTabsConfig } from './ads-tabs.types';
import type { TTabId } from '../../utils';

const AdsTabs = ({ activeTab, counts, onTabChange }: TAdsTabsConfig) => {
	const items: ITabItem[] = useMemo(
		() =>
			TAB_ORDER.map((tabId) => {
				const tab = TAB_CONFIG[tabId];
				const count = counts[tabId] ?? 0;

				return {
					text: tab.label,
					value: tabId,
					selected: activeTab === tabId,
					badgeContent: count > 0 ? count : undefined
				};
			}),
		[activeTab, counts]
	);

	const handleChange = useCallback(
		(item?: ITabItem) => {
			if (!item?.value) return;
			onTabChange(item.value as TTabId);
		},
		[onTabChange]
	);

	const tabKey = TAB_ORDER.map((id) => counts[id] ?? 0).join('-');

	return (
		<div
			className="w-full overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
			data-testid={MY_ADS_TEST_IDS.ADS_TABS}
			data-active-tab={activeTab}
		>
			<div className="w-fit">
				<Tab
					key={tabKey}
					items={items}
					size="small"
					badgeStyle={{ variant: 'primary', isOutlined: false }}
					onChange={handleChange}
					aria-label="Filtro de anúncios"
				/>
			</div>
		</div>
	);
};

AdsTabs.displayName = 'AdsTabs';

export { AdsTabs };
